import React from 'react';
import { Card, CardBody, Col } from 'reactstrap';
import Progressbar from '../../../../CommonElements/Progressbar';
import { ProgressBarsStates, ProgressBarstext } from '../../../../Constant';
import HeaderCard from '../../../Common/HeaderCard';

const States = () => {
  return (
    <Card>
      <HeaderCard title={ProgressBarsStates} span1={ProgressBarstext} />
      <CardBody className='card-body progress-showcase row'>
        <Col>
          <Progressbar color='primary' value='25' />
          <Progressbar color='secondary' value='50' />
          <Progressbar color='success' value='75' />
          <Progressbar color='info' value='100' />
        </Col>
      </CardBody>
    </Card>
  );
};

export default States;
